class DeferredCarousel extends HTMLElement {
  constructor() {
    super();
    this.COOKIE_NAME = 'preferred_model_view';
    this.debounceTimer = null;
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.addEventListener('scroll', this.handleScroll, { passive: true });


    // on page load, check if the preferred state is 'model' and scroll to the right
    if (window.innerWidth < 1024) {
      const preferredState = this.getCookie(this.COOKIE_NAME);
      if (preferredState === 'model') {
        this.scrollTo({ left: this.offsetWidth, behavior: 'smooth' });
      }
    }

    window.addEventListener('resize', this.handleResize);

    window.addEventListener('model-view-changed', (event) => {
      if (event.detail.state === 'model') {
        this.scrollTo({ left: this.offsetWidth, behavior: 'smooth' });
      } else {
        this.scrollTo({ left: 0, behavior: 'smooth' });
      }
    });
  }

  disconnectedCallback() {
    this.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    clearTimeout(this.debounceTimer);
  }

  handleResize() {
    clearTimeout(this.debounceTimer);

    this.debounceTimer = setTimeout(() => {
      this.debounceTimer = null;

      if (window.innerWidth < 1024) {
        const preferredState = this.getCookie(this.COOKIE_NAME);
        if (preferredState === 'model') {
          this.scrollTo({ left: this.offsetWidth, behavior: 'smooth' });
        } else {
          this.scrollTo({ left: 0, behavior: 'smooth' });
        }
      }
    }, 150);
  }

  handleScroll() {
    if (this.dataset.imagesLoaded === 'true') return;

    this.dataset.imagesLoaded = 'true';
    this.querySelectorAll('img[data-src]').forEach((image) => {
      image.srcset = image.dataset.srcset;
      image.src = image.dataset.src;
      image.removeAttribute('data-src');
      image.removeAttribute('data-srcset');
    });
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }
}

customElements.define('deferred-carousel', DeferredCarousel);
